import App from './App.svelte';
import './app.css';

interface UPFormConfig {
  target: HTMLElement;
  type?: 'Enquiry' | 'Referral' | 'Newsletter';
  endpoint?: string;
}

declare global {
  interface HTMLElement {
    __upform_instance?: App;
  }

  interface Window {
    UPForm?: {
      init: typeof initializeUPForm;
    };
  }
}

/**
 * Initializes or re-initializes the UPForm Svelte component.
 */
function initializeUPForm({ target, type = 'Enquiry', endpoint = '/enquiries' }: UPFormConfig) {
  if (!target) {
    console.error('UPForm: No target element provided.');
    return;
  }

  console.log('UPForm.init called with:', { target, type, endpoint });

  // Destroy any existing instance
  if (target.__upform_instance) {
    target.__upform_instance.$destroy();
  }

  // Create Svelte App instance using class API (compatibility.componentApi:4 enabled)
  const instance = new App({
    target,
    props: { type, endpoint }
  });

  target.__upform_instance = instance;
  return instance;
}

/**
 * Detect if page is running inside an iframe
 */
function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}


/**
 * Initialize form based on URL parameters (if present)
 */
function initFromUrlParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const type = (urlParams.get('type') as 'Enquiry' | 'Referral' | 'Newsletter') || 'Enquiry';
  const endpoint = urlParams.get('endpoint') || '/enquiries';

  const formContainer =
    document.getElementById('formContainer') || document.querySelector('.form-wrapper');

  if (formContainer) {
    // Update data attributes to match URL params
    formContainer.setAttribute('data-type', type);
    formContainer.setAttribute('data-endpoint', endpoint);

    // Initialize the form with the URL parameters
    initializeUPForm({
      target: formContainer as HTMLElement,
      type,
      endpoint
    });
  }
}

// Apply iframe-specific styles if needed
if (isInIframe()) {
  document.body.classList.add('is-iframe');
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  initFromUrlParams();
});

// Expose UPForm globally for external use
window.UPForm = {
  init: initializeUPForm
};

// Export for module usage
export { initializeUPForm as init };
